module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE0IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNGRjVGNzciIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTQuNTY1LjY1MmMwLS4zNi4yOTItLjY1Mi42NTItLjY1MmgyLjYxYy4zNiAwIC42NTEuMjkyLjY1MS42NTJoMy45MTNhLjY1Mi42NTIgMCAwIDEgMCAxLjMwNUguNjUyYS42NTIuNjUyIDAgMCAxIDAtMS4zMDVoMy45MTN6TTkuNTkzIDE1SDMuNDVjLS42NjUgMC0xLjIyMy0uNS0xLjI5Ny0xLjE2TC45NzggMy4yNmgxMS4wODdMMTAuODkgMTMuODRBMS4zMDUgMS4zMDUgMCAwIDEgOS41OTMgMTV6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/forms/delete.svg
// module id = ./src/assets/forms/delete.svg
// module chunks = 0